export const bangaloreMysoreOotyPackage = {
  id: "bangalore-mysore-ooty-6d5n",
  title: "Bangalore – Mysore – Ooty",
  country: "India",
  days: 6,
  nights: 5,
  priceOptions: [
    {
      option: "Option 1",
      cost: "₹27,400 per person + 5% GST",
      hotels: [
        {
          destination: "Ooty",
          nights: 3,
          hotel: "Preethi Classic or Similar",
          roomType: "Deluxe Room",
          mealPlan: "Breakfast",
        },
        {
          destination: "Mysore",
          nights: 2,
          hotel: "Hotel Preethi International or Similar",
          roomType: "Deluxe King Room",
          mealPlan: "Breakfast",
        },
      ],
    },
    {
      option: "Option 2",
      cost: "₹21,500 per person + 5% GST",
      hotels: [
        {
          destination: "Ooty",
          nights: 3,
          hotel: "The Majestic Crown or Similar",
          roomType: "Deluxe Room",
          mealPlan: "Breakfast",
        },
        {
          destination: "Mysore",
          nights: 2,
          hotel: "Heritage Suites or Similar",
          roomType: "Deluxe King Room",
          mealPlan: "Breakfast",
        },
      ],
    },
  ],

  thumbnail:
    "https://images.pexels.com/photos/32366710/pexels-photo-32366710.jpeg",

  description:
    "Explore the scenic beauty of Ooty, the royal heritage of Mysore, and the bustling city of Bangalore with this 6-day tour. Experience lush tea gardens, historic palaces, wildlife sanctuaries, and cultural landmarks in one comprehensive package.",

  highlights: [
    "Bandipur & Mudumalai Forest drive",
    "Pykara Lake, Pykara Falls & Shooting Point",
    "Ooty Lake, Rose Garden & Botanical Garden",
    "Coonoor sightseeing (Sim’s Park, Dolphin’s Nose, Lamb’s Rock)",
    "Mysore Palace & Chamundi Hill",
    "Brindavan Gardens musical fountain show",
  ],

  included: [
    "05 nights’ accommodation as per hotel option",
    "Daily breakfast at hotel",
    "2 Rooms on double sharing basis",
    "Transportation by AC Innova Crysta (A/C not operational in hill stations)",
    "Arrival & departure assistance",
    "Service-oriented driver",
  ],

  excluded: [
    "Airfare / train fare",
    "Monument entrance fees & camera charges",
    "Meals other than specified",
    "Heater charges (payable directly at hotel)",
    "Optional activities",
    "5% GST",
  ],

  itinerary: [
    {
      day: 1,
      title: "Bangalore – Ooty (En-route Sightseeing)",
      description:
        "Pickup from Bangalore Airport and drive to Ooty (approx. 350 km). En-route sightseeing includes Bandipur National Forest, Mudumalai Forest, Pykara Falls, Pykara Lake (boating), Shooting Point, and Pine Forest. Check-in at hotel. Overnight in Ooty.",
      photo: "https://images.pexels.com/photos/982021/pexels-photo-982021.jpeg",
    },
    {
      day: 2,
      title: "Ooty Full Day Sightseeing",
      description:
        "After breakfast, enjoy sightseeing in Ooty: Shooting Spot, Pykara Lake & Falls, Rose Garden, Ooty Lake, Botanical Garden, Chocolate Factory, and Tea Factory. Overnight stay in Ooty.",
      photo: "https://images.pexels.com/photos/32366710/pexels-photo-32366710.jpeg",
    },
    {
      day: 3,
      title: "Day Trip to Coonoor",
      description:
        "Breakfast at hotel and proceed to Coonoor. Visit Sim’s Park, Lamb’s Rock, Dolphin’s Nose, Ketti Valley viewpoint, Tea Factory & Museum, and Doddabetta Peak (highest in Nilgiris). Return to Ooty. Overnight in Ooty.",
      photo: "https://images.pexels.com/photos/25946627/pexels-photo-25946627.jpeg",
    },
    {
      day: 4,
      title: "Ooty – Mysore Sightseeing",
      description:
        "After breakfast, check out and drive to Mysore. Sightseeing includes Mysore Palace, Chamundi Hill, and Mysore Zoo (time permitting). Overnight stay in Mysore.",
      photo: "https://images.pexels.com/photos/9882016/pexels-photo-9882016.jpeg",
    },
    {
      day: 5,
      title: "Mysore Full Day Sightseeing",
      description:
        "Breakfast at hotel. Visit Chamundi Hill, Mysore Zoo, Mysore Palace, St. Philomena’s Church, Jagan Mohan Palace (Art Gallery), and Brindavan Gardens with musical fountain show in evening. Overnight in Mysore.",
      photo: "https://www.hlimg.com/images/things2do/738X538/brindavan-gardens-mysore-makemytrip-1513705991t.jpg",
    },
    {
      day: 6,
      title: "Mysore – Bangalore Departure",
      description:
        "Breakfast at hotel. Drive to Bangalore (approx. 260 km). Drop at airport / railway station. Tour ends with happy memories.",
      photo: "https://images.pexels.com/photos/739987/pexels-photo-739987.jpeg",
    },
  ],

  gallery: [
    // Day-wise itinerary photos first
    "https://images.pexels.com/photos/982021/pexels-photo-982021.jpeg", // Day 1 – Bandipur forest road
    "https://images.pexels.com/photos/32366710/pexels-photo-32366710.jpeg", // Day 2 – Ooty Rose Garden
    "https://images.pexels.com/photos/25946627/pexels-photo-25946627.jpeg", // Day 3 – Coonoor Dolphin’s Nose
    "https://images.pexels.com/photos/9882016/pexels-photo-9882016.jpeg", // Day 4 – Mysore Palace
    "https://www.hlimg.com/images/things2do/738X538/brindavan-gardens-mysore-makemytrip-1513705991t.jpg", // Day 5 – Brindavan Gardens
    "https://images.pexels.com/photos/739987/pexels-photo-739987.jpeg", // Day 6 – Vidhana Soudha Bangalore

    // Extra highlight shots
    "https://images.pexels.com/photos/8465212/pexels-photo-8465212.jpeg",
    "https://images.pexels.com/photos/16715671/pexels-photo-16715671.jpeg",
    "https://images.pexels.com/photos/28939074/pexels-photo-28939074.jpeg",
    "https://images.pexels.com/photos/27796542/pexels-photo-27796542.jpeg",
    "https://images.pexels.com/photos/19522934/pexels-photo-19522934.jpeg",
  ],

  groupDates: [
    { group: "Group 1", start: "2025-10-24", end: "2025-10-29" },
    { group: "Group 2", start: "2025-11-10", end: "2025-11-15" },
    { group: "Group 3", start: "2025-12-05", end: "2025-12-10" },
  ],

  brochure:
    "https://firebasestorage.googleapis.com/v0/b/paryatakadmin.firebasestorage.app/o/packages%2Fbangalore_mysore_ooty_brochure.pdf?alt=media&token=example",

  rating: {
    stars: 4.8,
    reviews: 120,
  },

  reviews: [
    {
      stars: 5,
      review: "A well-organized trip with beautiful sightseeing and comfortable hotels!",
      name: "Rohit Deshmukh",
    },
    {
      stars: 4,
      review: "Enjoyed Ooty and Coonoor. Driver was polite and supportive. Worth it.",
      name: "Priya Sharma",
    },
    {
      stars: 5,
      review: "The Mysore Palace and Brindavan Gardens were highlights. Highly recommend!",
      name: "Amit Kulkarni",
    },
  ],
};
